import React from 'react'
import { useSelector } from 'react-redux'

import * as customizationSelectors from 'customizer/customization/selectors'
import useThemeSettings from 'customizer/theme/useThemeSettings'

import './Title.scss'

const { customizerTitleSelector } = customizationSelectors

const Title = () => {
  const title = useSelector(customizerTitleSelector)
  const customizerTitleStyle = useThemeSettings('customizerTitle')

  if (title === '') return null

  return (
    <div
      className="title"
      style={{
        backgroundColor: customizerTitleStyle.backgroundColor,
        fontFamily: customizerTitleStyle.fontFamily?.fontFamily,
        fontSize: customizerTitleStyle.fontSize,
        color: customizerTitleStyle.color,
        borderBottomColor: customizerTitleStyle.dividerColor,
        borderBottomWidth: customizerTitleStyle.dividerWidth,
        marginBottom: +customizerTitleStyle.dividerWidth?.replace('px', '') > 0 ? '2rem' : '0',
      }}
    >
      {title}
    </div>
  )
}

export default Title
